<template>
	<div>
		<div class="product-add">
			<!--form表单-->
			<el-form size="small" label-width="150px">
				<div class="common-form">支付宝提现设置</div>
				<el-form-item label="appId">
					<el-input v-model="obj.appId" placeholder="请输入" class="max-w460"></el-input>
				</el-form-item>
				<el-form-item label="privateKey">
					<el-input v-model="obj.privateKey" type="textarea" :rows="5" placeholder="请输入"
						class="max-w460"></el-input>
				</el-form-item>
				<el-form-item label="appPublicCert">
					<!-- <el-input v-model="obj.appPublicCert" type="textarea" :rows="2" placeholder="请输入"
						class="max-w460"></el-input> -->
					<el-upload class="avatar-uploader" multiple ref="upload" action="string" accept=".crt"
						:before-upload="onBeforeUploadImage" :http-request="UploadImage" :show-file-list="false"
						:on-change="fileChange">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<div class="">
						<i class="el-icon-document"></i>
						<span>{{obj.appPublicCert}}</span>
					</div>
				</el-form-item>
				<el-form-item label="alipayPublicCert">
					<el-input v-model="obj.alipayPublicCert" type="textarea" :rows="2" placeholder="请输入"
						class="max-w460"></el-input>
				</el-form-item>
				<el-form-item label="alipayRootCert">
					<el-input v-model="obj.alipayRootCert" type="textarea" :rows="2" placeholder="请输入"
						class="max-w460"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="common-button-wrapper">
			<el-button type="primary" @click="onSubmit">提交</el-button>
		</div>
	</div>
</template>

<script>
	import settingApi from "@/api/setting.js";
	import FileApi from '@/api/file.js';
	export default {
		data() {
			return {
				obj: {},
				selectedFile: null
			};
		},
		created() {
			this.getDate();
		},
		methods: {
			getDate() {
				let self = this;
				settingApi.aliPayGET({}, true)
					.then(res => {
						self.obj = res.data.vars.values;
					})
					.catch(err => {});
			},
			onSubmit() {
				let self = this;
				settingApi.aliPayPOST(self.obj, true)
					.then(res => {
						if (res.code == 1) {
							this.$message({
								message: res.msg,
								type: "success"
							});
						}
					})
					.catch(err => {
						this.$message({
							message: err.msg,
							type: "warning"
						});
					});
			},
			/*选择上传图片*/
			fileChange(e) {
				this.selectedFile = e.raw; // 保存原始文件对象
			},

			/*选择图片之前*/
			onBeforeUploadImage(file) {
				const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
				const isLt1M = file.size / 1024 / 1024 < 1;
				if (!isIMAGE) {
					this.$message.error('上传文件只能是图片格式!');
				}
				if (!isLt1M) {
					this.$message.error('上传文件大小不能超过 1MB!');
				}
				return isIMAGE && isLt1M;
			},

			/*上传图片*/
			UploadImage(param) {
				let self = this;
				var formData = new FormData();
				formData.append('file', param.file);
				console.log("参数", formData)
				FileApi.aliPayFile(formData.get('file'))
					.then(response => {

						param.onSuccess(); // 上传成功的图片会显示绿色的对勾
						// 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
					})
					.catch(response => {
						self.$message({
							message: '本次上传图片失败',
							type: 'warning'
						});
						param.onError();
					});
			},
		}
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/setting/withdraw/index - 副本.vue